"use client";

import { FetchError } from "@saas/core/fetch/fetch-error/fetch-error";
import { QueryOptionsInterface } from "@saas/shared/utils/^interface/query-options/query-options.interface";

import {
  featureFlagsQueryKey,
  getFeatureFlagsStatus,
  GetFeatureFlagsStatusOutput,
} from "../..";

import { useQuery } from "@tanstack/react-query";

export type UseFeatureFlagsStatusQueryData = GetFeatureFlagsStatusOutput;

export const useFeatureFlagsStatusQuery = <
  DerivedQueryData = UseFeatureFlagsStatusQueryData
>(
  options?: QueryOptionsInterface<
    UseFeatureFlagsStatusQueryData,
    DerivedQueryData
  >
) => {
  return useQuery<UseFeatureFlagsStatusQueryData, FetchError, DerivedQueryData>(
    featureFlagsQueryKey.status(),
    async () => {
      const data = await getFeatureFlagsStatus();

      return data;
    },
    {
      ...options,
      select: options?.select,
      enabled: options?.enabled,
    }
  );
};

export default useFeatureFlagsStatusQuery;
